package com.essntl.core.quickbooks.data

import com.essntl.core.quickbooks.data.QuickbooksClientImpl.Companion.BusinessValidationErrorCode
import com.essntl.core.quickbooks.data.QuickbooksClientImpl.Companion.DuplicateNameErrorCode
import io.ktor.client.call.*
import io.ktor.client.statement.*
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.intOrNull

suspend fun HttpResponse.isDuplicateNameError(): Boolean {
    if (status.value.toString().startsWith('4')) {
        val errorMessage = body<Map<String, JsonElement>>()
        val fault = errorMessage["Fault"] as? JsonObject
        val error = fault?.get("Error") as? JsonArray
        val errorObject = error?.get(0) as? JsonObject
        val errorCode = (errorObject?.get("code") as? JsonPrimitive)?.intOrNull

        return errorCode == DuplicateNameErrorCode || errorCode == BusinessValidationErrorCode
    } else {
        return false
    }
}